import React, { useEffect, useState, useRef } from "react";
import OverviewCard from "../components/OverviewCard";
import { ContentWrapper, Center } from "../styled-components/shared";
import { PageTitle } from "../styled-components/shared";
import styled from "styled-components";
import EmptyModal from "../components/modals/EmptyModal";
import { NoDataMessage } from "../components/NoDataMessage";
import CsvCompModal from "../components/modals/CsvCompModal";
import { ScanenrConfigData } from '../components/CSVCompConfig';

import { Table } from "@zebra-fed/zds-react-desktop";
import CircularProgress from "@material-ui/core/CircularProgress";
import config from "../data/application.properties";
import app from "../authentication/firebaseStart";
import "@zebra-fed/icons/Keyboard/index.css";
import { useTranslation } from "react-i18next";
import BottomNavLinks from "../components/BottomNavLinks";
import { Button } from "@zebra-fed/zds-react-desktop/components";
const axiosInstance = require("../axios/axios").default;

const firestore = app.firestore();
const DEFAULT_ROWS_PER_PAGE = 10;

const HorizontalDivider = styled.div`
  height: 2px;
  /* background: #8e8e8e;*/
  margin: 15px auto;
`;

const StyledContentWrapper = styled(ContentWrapper)`
  margin-bottom: 32px;
`;

const SecondaryTitle = styled.div`
  font-size: 1.1rem;
  padding-bottom: 20px;
  font-weight: bold;
`;

const TableWrapper = styled.div`
  & tr:hover {
    background: white;
  }
`;

const LicenseSummary = () => {
  const [licenseData, setLicenseData] = useState();
  const [licenseDataBTScanners, setLicenseDataBTScanners] = useState();
  const [expiryData, setExpiryData] = useState();
  const [expiryDataBTScanners, setExpiryDataBTScanners] = useState();
  const [lastSyncTime, setLastSyncTime] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [devicesData, setDevicesData] = useState(true);
  const [errorModalText, setErrorModalText] = useState("");
  const [errorModalHeaderText, setErrorModalHeaderText] = useState("");
  const [preButtonStyle, setPreButtonStyle] = useState("normal");
  const modalRef = useRef();
  const CsvCompModalRef = useRef();
  const [manageBtnValue, setManageBtnValue] = useState({})


  const { t } = useTranslation()

  useEffect(() => {
    getLicenseDeviceData();
    getFlexeraTime();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getLicenseDeviceData = async () => {
    console.log("Getting license from :" + config.FETCH_LICENSE_SUMMARY);
    axiosInstance.post(config.FETCH_LICENSE_SUMMARY, {}).then(response => {
      let res = response.data;
      console.log("received: ", res);
      setLicenseData(
        Object.entries(res.details.consolidatedLicenseSummary).map(e => ({
          [e[0]]: e[1],
        }))
      );

      setLicenseDataBTScanners(
        Object.entries(res.details.ConsolidatedAccessoryLicenseSummary).map(e => ({
          [e[0]]: e[1],
        }))
      );

      setDevicesData(
        Object.entries(res.details.deviceLicenseSummary).map(e => ({
          [e[0]]: e[1],
        }))
      );

      var expArray = [];
      var expArrayBTScanners = [];
      res.details.expiry.forEach(function (item) {
        if (item.featureName == "dts-accessory-feature-std") {
          expArrayBTScanners.push({
            count: item.count,
            expiresAt: item.expiresAt
          })
        }
        if (item.featureName == "dts-feature-std") {
          expArray.push({
            count: item.count,
            expiresAt: item.expiresAt
          })
        }

      })
      setExpiryData(expArray);
      setExpiryDataBTScanners(expArrayBTScanners);
      setIsLoading(false);
    }).catch(error => {
      console.log("getLicenseDeviceData Error: ", error)
      showErrorModal(error, t('messages.error.err28'));
      setExpiryData([]);
      setExpiryDataBTScanners([]);

      //setLicenseData([]);
      //setLicenseDataBTScanners([]);
      //setDevicesData([]);
      setIsLoading(false)
    })
  };

  const getFlexeraTime = async () => {
    let document = await (
      await firestore.collection("FlexeraSyncStatus").doc("status").get()
    ).data();

    if (document !== undefined) {
      let lastSyncTime = document.lastSyncTime;
      setLastSyncTime(t('messages.success.last_sync', { lastSyncTime }));//`Last sync: ${document.lastSyncTime}`
      setPreButtonStyle("normal");
    } else {
      setLastSyncTime(t("messages.error.err29"));//"Unable to sync with server."
      setPreButtonStyle("error");
    }
  };

  const refreshFlexera = async () => {
    setIsLoading(true);
    setLastSyncTime(t('syncingNow')) //Syncing now...
    setPreButtonStyle("error");
    axiosInstance.post(config.FLEXERA_REFRESH_URL, {}).then(response => {
      let res = response.data;
      if (res.status === "OK") {
        getLicenseDeviceData();
        getFlexeraTime();
      } else {
        showErrorModal(res["details"], t('messages.error.err28'));
        setIsLoading(false);
        setLastSyncTime(t("messages.error.err29"));//"Unable to sync with server."
        setPreButtonStyle("error");
      }
    }).catch(error => {
      console.log("refreshFlexera Error: " + JSON.stringify(error))
      showErrorModal(t('messages.error.err30'), t('messages.error.err31'));//Cannot connect to server`, "Connection error"
      setIsLoading(false);
    })
  };

  const showErrorModal = (errorMessage, errorHeader) => {
    setErrorModalText(errorMessage);
    setErrorModalHeaderText(errorHeader);
    modalRef.current.toggleDialog();
  };

  const StyledCircle = () => {
    return (
      <Center>
        <CircularProgress />
      </Center>
    );
  };
  function onCancelHit() {
  }
  function refreshPageClicked() {

  }
  function onDeleteLicensesBtn() {
    setManageBtnValue({ name: t('csvModal.ReleaseLicensesTitle'), 
    value: "DELETE", page: 'LICENSES',description:t('csvModal.ReleaseLicensesDesc') })
    CsvCompModalRef.current.toggleDialog();
  }


  return (
    <>
      <StyledContentWrapper>
        <OverviewCard
          isLoading={isLoading}
          title={t('licenseOverview')}
          data={licenseData}
          onClick={() => refreshFlexera()}
          preButtonData={lastSyncTime}
          preButtonStyle={preButtonStyle}
          onRowHovered={() => { }}
          tooltip={t('refreshDB')}
          important="available"
        />
        <HorizontalDivider />

        {expiryData && expiryData.length > 0 && !isLoading ? (
          <TableWrapper>
            <Table
              pageSize={
                expiryData.length > DEFAULT_ROWS_PER_PAGE
                  ? DEFAULT_ROWS_PER_PAGE
                  : expiryData.length
              }
              pages={expiryData.length > DEFAULT_ROWS_PER_PAGE ? true : false}
              checkbox={false}
              type="default"
              defaultData={expiryData}
              headerStyle={{ backgroundColor: "#F5F5F5" }}
              showSort={true}
              style={{ background: "white" }}
              defaultHeaders={[
                { name: t('licenseCount'), hideSort: true },
                { name: t('expirationDate'), hideSort: true }
              ]}
            />
          </TableWrapper>
        ) : (!expiryData || expiryData.length === 0) && !isLoading ? (
          <NoDataMessage>{t('messages.error.err27')}</NoDataMessage>
        ) : (
          <StyledCircle />
        )}

        <OverviewCard
          isLoading={isLoading}
          title={t('licenseOverviewBTScanners')}
          data={licenseDataBTScanners}
          onClick={() => onDeleteLicensesBtn()}
          preButtonData=""
          preButtonStyle={preButtonStyle}
          buttonText = {t('deleteAccessoryLicense')}
          onRowHovered={() => { }}
          tooltip={t('refreshDB')}
          important="available"
        />
       
        <CsvCompModal
          modalRef={CsvCompModalRef}
          importType={manageBtnValue}
          ConfigData={ScanenrConfigData}
          refreshPage={refreshPageClicked}
          
          // sitesData={sitesData}
          // devicesData={devicesData}
          // hasUpdatedTime={hasUpdatedTime}
          // isLoadingCsv={isLoadingCsv}
          onCancelHit={onCancelHit}
        />
        <HorizontalDivider />
        {expiryDataBTScanners && expiryDataBTScanners.length > 0 && !isLoading ? (
          <TableWrapper>
            <Table
              pageSize={
                expiryDataBTScanners.length > DEFAULT_ROWS_PER_PAGE
                  ? DEFAULT_ROWS_PER_PAGE
                  : expiryDataBTScanners.length
              }
              pages={expiryDataBTScanners.length > DEFAULT_ROWS_PER_PAGE ? true : false}
              checkbox={false}
              type="default"
              defaultData={expiryDataBTScanners}
              headerStyle={{ backgroundColor: "#F5F5F5" }}
              showSort={true}
              style={{ background: "white" }}
              defaultHeaders={[
                { name: t('licenseCount'), hideSort: true },
                { name: t('expirationDate'), hideSort: true },
              ]}
            />
          </TableWrapper>
        ) : (!expiryDataBTScanners || expiryDataBTScanners.length === 0) && !isLoading ? (
          <NoDataMessage>{t('messages.error.err27')}</NoDataMessage>
        ) : (
          <StyledCircle />
        )}
        <BottomNavLinks />
      </StyledContentWrapper>

      {/* <StyledContentWrapper>
        <OverviewCard
          isLoading={isLoading}
          title="Device License Overview"
          data={devicesData}
          important='unlicensed'
        />
      </StyledContentWrapper> */}
      <EmptyModal
        modalRef={modalRef}
        header={errorModalHeaderText}
        color="#ED1C24"
        content={errorModalText}
      />
    </>
  );
};
export default LicenseSummary;